import { TApplicationState } from '../../types/redux';

export const selectIsCityAds = (state: TApplicationState) => {
  return Boolean(state.cpa.cityAds);
};
